// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1yDqh","left":"InfoRow_left__3t5PK"};